<template>
	<div class="action-button-wrapper divide">
      <b-button size="sm" variant="link" class="site-action-btn" @click="emitAction('viewBackups')">
          <span class="icon-cont">
              <view-backups-icon class="icon-default view-backups-icon"></view-backups-icon>
          </span>
          <span>View backups</span>
      </b-button>
  </div>
</template>

<script>
import ViewBackupsIcon from '../../assets/viewbackups.svg';
export default {
  name: "viewsite",
  props: ["site"],
  components:{
  	ViewBackupsIcon
  },
  data() {
    return {
      serverURL: window.serverURL,
    };
  },
  methods:{
    emitAction(action) {
      this.$emit('action', { action: action, site: this.site });
    },
  }
};
</script>